import * as haircareProducts from '../assets/content/haircareProducts';
import * as skincareProducts from '../assets/content/skincareProducts';

// We do need to add a different namespace to the imported
// products so as the eslint doesn't complain. This is also
// required as we cannot tunnel through imported namespaces;
const availableProducts = { ...haircareProducts, ...skincareProducts };

export const getProductPageUrl = product => {
  if (!(product in availableProducts)) {
    // Returns link to the product page if the product doesn't exist yet
    return '/products/';
  }
  return availableProducts[product].productPageUrl;
};
